import React from 'react';
import { IconAlertTriangle } from 'src/icons';

interface ErrorBannerProps {
  message: string;
  onRetry: () => void;
}

export function ErrorBanner({ message, onRetry }: ErrorBannerProps) {
  return (
    <div className="flex items-center gap-1 bg-red-50 mb-1 p-1 border border-red-200 rounded shrink-0">
      <IconAlertTriangle className="flex-shrink-0 w-3 h-3 text-red-500" />
      <span className="flex-1 min-w-0 text-[10px] text-red-700 truncate">{message}</span>
      <button type="button" onClick={onRetry} className="bg-red-100 hover:bg-red-200 px-1.5 py-0.5 rounded text-[10px] text-red-700 shrink-0">
        Retry
      </button>
    </div>
  );
}
